import { render, staticRenderFns } from "./NavbarMain.vue?vue&type=template&id=47c20d97&scoped=true&"
import script from "./NavbarMain.vue?vue&type=script&lang=js&"
export * from "./NavbarMain.vue?vue&type=script&lang=js&"
import style0 from "./NavbarMain.vue?vue&type=style&index=0&id=47c20d97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c20d97",
  null
  
)

export default component.exports